export default __webpack_public_path__ + "static/media/legend-active.c4a13046.svg";